import { QuestionMark } from "@mui/icons-material";
import BasicButton from "components/BasicInputs/BasicButton";
import { Formik } from "formik";
import Steps from "./steps";
import { store } from "store/store";

export default function TaxClientSettings() {
    const Businesse = store.getState().businessReducer.business.business
    const init: TaxClientSettingsData = {
        fiscalFolderId: Businesse.fiscalFolderId,
        taxId: Businesse.taxId

    };

    return (
        <Formik initialValues={init} onSubmit={() => {
        }}>
            <>
                <div className="flex items-center justify-between gap-4 mb-6">
                    <div className="text-lg font-bold">اتصال به سامانه مودیان</div>
                    <BasicButton>
                        <QuestionMark />
                        <span>راهنمای اتصال به سامانه مودیان</span>
                    </BasicButton>
                </div>
                <Steps />
            </>
        </Formik>
    );
}
